import React, {useState, useRef, useEffect, Fragment} from 'react';
import TitleWithIcon from '../TitleWithIcon'
import VisDiv from '../frontend_components/VisDiv'
import Divider from '../frontend_components/Divider'
import OfferTotals from './OfferTotals'
import {IoIosEye, IoIosEyeOff, IoMdCart } from 'react-icons/io';
import { useStateContext } from '../../context/StateContext';
import UpdateOfferFromRegister from './UpdateOfferFromRegister';
import { errorAlert, htmlInfoLine, mergeArraysById } from '../../lib/utils';
import { referenceDoc } from '../gestioneDatabase/Docs';
import Swal from 'sweetalert2';
import { FaMapSigns } from "react-icons/fa";
import { HiddenOfferData } from './HiddenOfferData';
import TestButton, { InfoButton } from '../frontend_components/TestButton';


const RegisterHeader = ({data={}, hideShowRegister = () => {}}) => {
 //#offerTotals
 const {clientOrder, register, siteOffer, registerTemplate, offerDataWithSigns, offerTotals, productsMissing, iconLink, infoProducts, offerData, reportData} = data  

 //const {offer, setOffer, setIsEditingOffer, forceReload, forceLoad,} = useStateContext()
 //console.log("IN CONSOLE HEADER", registerTemplate)
 const [showMissing, setShowMissing] = useState(false)
 const workedData = offerDataWithSigns ? offerDataWithSigns : offerData
 const onRowClick = () => {
  console.log("CLICKED REGISTER ROW", workedData, register)
 }
 //console.log("CLICKED REGISTER ROW", data)
 const registerName = register?.registerName? register?.registerName: ""
 const offerTitle = registerTemplate?.offerTitle ? registerTemplate?.offerTitle : registerTemplate?.family
 const registerFullName = `${offerTitle} ${registerName}`
const registerId = () => 
  { 
    const isSignRegister = offerDataWithSigns?.length > 0
    if(isSignRegister) return "weduwheiudghyegwuyjke88363ghdloiejdf87"
    return register?._id
  }
const allProductsHidden = workedData?.every?.((x)=>x?.hide)
const isRegisterHidden = siteOffer?.hideRegisters?.some?.((y)=> y == registerId())

const orderWorkedData = !Array.isArray(workedData) ? [] : workedData?.filter?.((x)=>{
  return x?.clientOrder?._ref == clientOrder?._id || !x?.clientOrder
})
const areAllInThisOrder = orderWorkedData?.every?.((x)=>x?.clientOrder)

const addToOrder = () => { 
  //#showHideOrder
  console.log("ADD TO ORDER", orderWorkedData)
  const allOrder = orderWorkedData?.map?.((item)=>({...item, clientOrder: referenceDoc(clientOrder?._id)}))
  const updatedData = mergeArraysById(workedData, allOrder)
  const updatedFieldsData = mergeArraysById(siteOffer?.offerFields, updatedData)
  const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
  hideShowRegister(updatedOfferDoc)
}
const removeFromOrder = () => { 
  //#showHideOrder
  console.log("REMOVE FROM ORDER", orderWorkedData)
  const allOrder = orderWorkedData?.map?.((item)=>({...item, clientOrder: undefined}))
  const updatedData = mergeArraysById(workedData, allOrder)
  const updatedFieldsData = mergeArraysById(siteOffer?.offerFields, updatedData)
  const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
  hideShowRegister(updatedOfferDoc)
}


const registerSigns = HiddenOfferData({offerData: siteOffer?.offerFields?.filter?.((x)=>x?.isSign && x?.registerId == register?._id && !x?.labourProduct), allOffers: [siteOffer]})
const areRegisterSignsHidden = () => {
  if(!Array.isArray(registerSigns)) return true
  if(registerSigns?.every?.((x)=>x?.hide)) return true
  return false
}
const isRegisterSignHidden = siteOffer?.hideRegisters?.some?.((x)=>x == "weduwheiudghyegwuyjke88363ghdloiejdf87") ? true : false
const showRegisterSigns = () => {
    if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const showRegisterSigns = !Array.isArray(registerSigns) ? [] : registerSigns?.map((x)=>({...x, hide: false}))
  const filterOutSignsToShow = !Array.isArray(siteOffer?.offerFields) ? [] : siteOffer?.offerFields?.filter?.((x)=>!registerSigns?.some?.((y)=>y?._id == x?._id))
  const updatedOffer = {...siteOffer, offerFields: [...filterOutSignsToShow, ...showRegisterSigns]}
  console.log("SHOW REGISTER SIGNS", {siteOffer, signs: registerSigns, filterOutSignsToHide: filterOutSignsToShow, hiddenRegisterSigns: showRegisterSigns, updatedOffer})
  hideShowRegister(updatedOffer)


}
const hideRegisterSigns = () => {
 
    if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const hiddenRegisterSigns = !Array.isArray(registerSigns) ? [] : registerSigns?.map((x)=>({...x, hide: true}))
  const filterOutSignsToHide = !Array.isArray(siteOffer?.offerFields) ? [] : siteOffer?.offerFields?.filter?.((x)=>!registerSigns?.some?.((y)=>y?._id == x?._id))
  const updatedOffer = {...siteOffer, offerFields: [...filterOutSignsToHide, ...hiddenRegisterSigns]}
  console.log("HIDE REGISTER SIGNS", {siteOffer, signs: registerSigns, filterOutSignsToHide, hiddenRegisterSigns, updatedOffer})
  hideShowRegister(updatedOffer)
}

 const showRegister = () => {
  //#showHideOffer
  console.log("SHOW REGISTER", {siteOffer})
  if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const hideRegister = {
    ...siteOffer,
    hideRegisters:[...!Array.isArray(siteOffer?.hideRegisters) ? [] : siteOffer?.hideRegisters?.filter?.((x)=>x != registerId())]
  }
  hideShowRegister(hideRegister)

 }
 const hideRegister = () => {
  //#showHideOffer
  console.log("Hide REGISTER", siteOffer)

  if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const hideRegister = {
    ...siteOffer,
    hideRegisters:[...!Array.isArray(siteOffer?.hideRegisters) ? [] : siteOffer?.hideRegisters, registerId()]
  }
  hideShowRegister(hideRegister)

 }

 const addFields = async(data) => {
   console.log("FIELDS TO ADD IN REGISTER HEADER", data)
   const updatedFieldsData = !Array.isArray(siteOffer?.offerFields) ? [] : [...siteOffer?.offerFields, ...data]
   const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
   console.log("FIELDS TO ADD IN REGISTER HEADER", {updatedFieldsDataFiltered: updatedFieldsData?.filter?.((x=>x)), updatedFieldsData, newFields: data, offer: siteOffer, updatedOfferDoc})
   hideShowRegister(updatedOfferDoc)
   Swal.fire({
    position: 'top',
    icon: 'success',
    title: "RICARICA LA PAGINA",
    showConfirmButton: false,
    timer: 1500
  })
 }
 const headerBackground = () => {
  if(register?.status == "ARCHIVIATO") return "lightgrey"
  if(register?.notInMaintenance) return "#FFDBBB"
  return "transparent"
 }
 //console.log("CUSTOMER PRODUCT NON TROVATO", productsMissing)
 return (
   <div onClick={onRowClick}>
      <Divider/> 
      <div className='dskh-siteinfo' style={{backgroundColor: headerBackground(),}}>  
        <VisDiv  rules={[!clientOrder]} className='side' style={{alignItems:"center"}}>
          <VisDiv rules={[workedData?.length>0]} style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}}>
            <VisDiv className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}} rules={[isRegisterHidden]} onClick={(e) => {showRegister()}}>
              <IoIosEyeOff fontSize={25} color='white'/>
            </VisDiv>
            <VisDiv className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} rules={[!isRegisterHidden]} onClick={(e) => {hideRegister()}}>
              <IoIosEye fontSize={25} color='white' />
            </VisDiv>
          </VisDiv>
          <VisDiv  rules={[!offerDataWithSigns, registerSigns?.length > 0, !isRegisterSignHidden]} style={{alignItems:"center", marginLeft:"15px"}}>
            <VisDiv rules={[areRegisterSignsHidden()]} className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}}  onClick={(e) => {showRegisterSigns()}}>
              <FaMapSigns fontSize={25} color='white'/>
            </VisDiv>
            <VisDiv rules={[!areRegisterSignsHidden()]} className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} onClick={(e) => {hideRegisterSigns()}}>
              <FaMapSigns fontSize={25} color='white' />
            </VisDiv>
          </VisDiv>
        </VisDiv>
        <VisDiv  rules={[clientOrder]} className='side' style={{alignItems:"center"}}>
          <VisDiv rules={[!areAllInThisOrder]} className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}}  onClick={(e) => {addToOrder()}}>
            <IoMdCart fontSize={25} color='white'/>
          </VisDiv>
          <VisDiv rules={[areAllInThisOrder]} className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} onClick={(e) => {removeFromOrder()}}>
            <IoMdCart fontSize={25} color='white' />
          </VisDiv>
        </VisDiv>



        <div className='center' style={{flexDirection:"column", alignItems:"center", flex:1}} > 
          <div style={{display:"flex", alignItems:"center"}}>
            <VisDiv rules={[iconLink]}>
              <img src={iconLink} alt="offer-icon" className='offer-icon-image'/> 
            </VisDiv>
            <TitleWithIcon
            iconSize={40}
            fontSize={12}
            icon={registerTemplate?.icon}
            title={registerFullName}
            />
          </div>

          <VisDiv  rules={[register?.status == "ARCHIVIATO"]} style={{color:"red", textAlign:"center"}}>
            <h3>
              ARCHIVIATO
            </h3>
          </VisDiv>
          <VisDiv  rules={[register?.notInMaintenance]} style={{color:"orange", textAlign:"center"}}>
            <h3>
              NON IN MANUTENZIONE
            </h3>
          </VisDiv>
        </div>
        <div className='right-side' style={{display:"flex", flexDirection: "column", alignItems:"flex-end", marginRight:"20px"}}>
          <OfferTotals offerTotals={offerTotals}/>
        </div>
      </div>                          

      <ProductsDropdown registerTemplate={registerTemplate} customerProductsArray={productsMissing} />
      <ProductsDropdown registerTemplate={registerTemplate} customerProductsArray={infoProducts} text={"PRODOTTI INFORMATIVI"} barColor={"blue"} />
      <VisDiv rules={[siteOffer]} style={{marginTop: "10px", color:"darkBlue", cursor:"pointer", }}>
        <UpdateOfferFromRegister offerData={workedData} reportData={reportData} addFields={addFields}/>
      </VisDiv>
      <Divider/>
   
   </div>
  )
}

export default RegisterHeader

export const ProductsDropdown = ({registerTemplate, customerProductsArray, text = "CI SONO PRODOTTI MANCANTI", barColor = "red"}) => {
  const [show, setShow] = useState(false)

  return (
  <VisDiv rules={[customerProductsArray?.length > 0]}>
    
    <VisDiv style={{marginTop:"10px",backgroundColor: barColor, color:"white", textAlign:"center"}}  onClick={()=>setShow(!show)}>
      {text}
    </VisDiv>
    <VisDiv rules={[show]}>
          {customerProductsArray?.map?.((item, index)=>{
            const positions = item?.deviceNonConformities?.map?.((obj)=>{
              //console.log("wkjndkewjnd", {obj, item, registerTemplate})
              const noProperties = obj?.device?.fields?.length < 1
              const registerHasOfferPropertyRef = registerTemplate?.offerProperty?._ref
              const requiredOfferProperty = obj?.device?.fields?.some?.((x)=>x?.templateField?._ref == registerHasOfferPropertyRef)
              const requiredOfferPropertyString = (!requiredOfferProperty && registerHasOfferPropertyRef) ? ` Il presidio richiede l'assegnazione di una proprieta'. ` : ""
              const noPropertiesString = noProperties &&  registerHasOfferPropertyRef ? ` Il presidio non ha proprieta' assegnate. ` : ""
              return ` Presidio ${obj?.device?.label} in posizione ${obj?.device?.positionNumber}.${noPropertiesString} ${requiredOfferPropertyString}`
            })
              const infoHtml = () => {
              const htmlData = `
                <div style="text-align: center; border: 1px solid lightgrey; border-radius: 10px; padding: 20px;">
                  
                    ${htmlInfoLine({value: item?.label, title: "NON CONFORMITA'"})} 
                </div>
                `
                
                return htmlData
              } 
            const consoleData = {item, index, positions}
            return (
            <div onClick={()=>console.log("MANCA PRODOTTO", {item, })} key={index} style={{padding:"10px"}}>
              
              <VisDiv style={{display:"flex", flexDirection:"column"}}>
                <TestButton buttonId='qwskoqwkoqp' message='missing products' consoleData={consoleData}/>
                <VisDiv style={{color:"darkBlue"}} rules={[]}>
                  <InfoButton buttonId={"olmdlqwmxdlkamwdx"} consoleData={consoleData} html={infoHtml()} />
                </VisDiv>

                <h3>{item?.label} </h3>
                <p>
                  {positions?.toString()}
                </p>
                <VisDiv rules={[item?.deviceNonConformities?.length<1]}>
                <p>Non ci sono presidi associati</p>
                </VisDiv>
              
              </VisDiv>
            </div>
            )
          })}
    </VisDiv>
      
  </VisDiv>
  )
}

